const c = {
  name: "Brussels",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<path class="st0" d="M21,14.2V9.8c1.2-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3c-0.8,0-1.5,0.3-2.1,0.8L15,3.4c0-0.1,0-0.2,0-0.4
	c0-1.7-1.3-3-3-3S9,1.3,9,3c0,0.1,0,0.2,0,0.4L6.1,4.8C5.5,4.3,4.8,4,4,4C2.3,4,1,5.3,1,7c0,1.3,0.8,2.4,2,2.8v4.3
	c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3c0.8,0,1.5-0.3,2.1-0.8L9,20.6c0,0.1,0,0.2,0,0.4c0,1.7,1.3,3,3,3s3-1.3,3-3
	c0-0.1,0-0.2,0-0.4l2.9-1.5c0.5,0.5,1.3,0.8,2.1,0.8c1.7,0,3-1.3,3-3C23,15.7,22.2,14.6,21,14.2z M19.1,6.6L19.1,6.6
	C19.3,6.2,19.6,6,20,6c0.5,0,1,0.5,1,1s-0.5,1-1,1s-1-0.5-1-1C19,6.9,19,6.7,19.1,6.6z M17,6.6c0,0.1,0,0.2,0,0.4
	c0,0.2,0,0.4,0.1,0.7l-3.2,2c-0.3-0.2-0.5-0.4-0.9-0.5V5.8c0.4-0.2,0.8-0.4,1.1-0.7L17,6.6z M12,2c0.5,0,1,0.5,1,1
	c0,0.2,0,0.3-0.1,0.4l0,0.1C12.7,3.8,12.4,4,12,4c-0.4,0-0.7-0.2-0.9-0.5l0-0.1C11,3.3,11,3.1,11,3C11,2.5,11.5,2,12,2z M13,12
	c0,0.5-0.5,1-1,1s-1-0.5-1-1s0.5-1,1-1S13,11.5,13,12z M7,6.6l2.9-1.5c0.3,0.3,0.7,0.5,1.1,0.7v3.3c-0.3,0.1-0.6,0.3-0.9,0.5l-3.2-2
	C7,7.4,7,7.2,7,7C7,6.9,7,6.8,7,6.6z M4,6c0.4,0,0.7,0.2,0.9,0.5l0,0.1C5,6.7,5,6.8,5,7c0,0.5-0.5,1-1,1S3,7.5,3,7S3.5,6,4,6z
	 M4.9,17.4L4.9,17.4C4.7,17.8,4.4,18,4,18c-0.5,0-1-0.5-1-1s0.5-1,1-1s1,0.5,1,1C5,17.2,5,17.3,4.9,17.4z M5.9,14.7
	c-0.3-0.2-0.5-0.4-0.9-0.5V9.8c0.3-0.1,0.6-0.3,0.9-0.5l3.2,2C9,11.6,9,11.8,9,12s0,0.4,0.1,0.7L5.9,14.7z M7,17.4
	c0-0.1,0-0.2,0-0.4c0-0.2,0-0.4-0.1-0.7l3.2-2c0.3,0.2,0.5,0.4,0.9,0.5v3.3c-0.4,0.2-0.8,0.4-1.1,0.7L7,17.4z M12,22
	c-0.5,0-1-0.5-1-1c0-0.1,0-0.3,0.1-0.4l0-0.1c0.2-0.3,0.5-0.5,0.9-0.5c0.4,0,0.7,0.2,0.9,0.5l0,0.1C13,20.7,13,20.8,13,21
	C13,21.5,12.5,22,12,22z M17,17.4l-2.9,1.5c-0.3-0.3-0.7-0.5-1.1-0.7v-3.3c0.3-0.1,0.6-0.3,0.9-0.5l3.2,2c0,0.2-0.1,0.4-0.1,0.7
	C17,17.1,17,17.2,17,17.4z M14.9,12.7c0-0.2,0.1-0.4,0.1-0.7s0-0.4-0.1-0.7l3.2-2c0.3,0.2,0.5,0.4,0.9,0.5v4.3
	c-0.3,0.1-0.6,0.3-0.9,0.5L14.9,12.7z M20,18c-0.4,0-0.7-0.2-0.9-0.5l0-0.1c0-0.1-0.1-0.3-0.1-0.4c0-0.5,0.5-1,1-1s1,0.5,1,1
	S20.5,18,20,18z"/>
</svg>
  `
};
export {
  c as Brussels
};
